import {
  NavigationProp,
  StackActions,
  useNavigation,
} from "@react-navigation/native";
import graphql from "babel-plugin-relay/macro";
import { useEffect } from "react";
import { useFragment } from "react-relay";

import { ClubStackNavigatorParamList } from "../../../../navigators/ClubNavigator";
import { useHandleUserAlreadyInBooking_Booking$key } from "./__generated__/useHandleUserAlreadyInBooking_Booking.graphql";
import { useHandleUserAlreadyInBooking_Session$key } from "./__generated__/useHandleUserAlreadyInBooking_Session.graphql";

export const useHandleUserAlreadyInBooking = (
  bookingRef: useHandleUserAlreadyInBooking_Booking$key | null,
  sessionRef: useHandleUserAlreadyInBooking_Session$key | null
) => {
  const booking = useFragment(
    useHandleUserAlreadyInBookingFragmentString,
    bookingRef
  );
  const bookingId = booking?.id;
  const session = useFragment(
    useHandleUserAlreadyInBookingSessionFragmentString,
    sessionRef
  );
  const navigation =
    useNavigation<NavigationProp<ClubStackNavigatorParamList>>();
  const currentClientId = session?.currentClientProfile?.member?.id;
  const hasUserAlreadyJoinedBooking =
    !!currentClientId &&
    booking?.rounds?.edges?.some(
      (round) => round?.node?.player?.id === currentClientId
    );
  useEffect(() => {
    if (hasUserAlreadyJoinedBooking && bookingId) {
      navigation.dispatch(
        StackActions.replace("BookingSummary", { slotOrBookingId: bookingId })
      );
    }
  }, [hasUserAlreadyJoinedBooking, bookingId, navigation]);
};
const useHandleUserAlreadyInBookingFragmentString = graphql`
  fragment useHandleUserAlreadyInBooking_Booking on Booking {
    id
    rounds {
      edges {
        node {
          player {
            id
          }
        }
      }
    }
  }
`;

const useHandleUserAlreadyInBookingSessionFragmentString = graphql`
  fragment useHandleUserAlreadyInBooking_Session on Session {
    currentClientProfile {
      __typename
      member {
        ... on Customer {
          id
        }
        ... on Member {
          id
        }
      }
    }
  }
`;
